module.exports = __webpack_public_path__ + "static/media/feature-1.791f9269.png";